import React, { PropTypes } from "react";
import CurrentWebinarItem from "./CurrentWebinarItem";
import { FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";

const CurrentWebinars = ({
  webinars,
  nextPage,
  pagination,
  count,
  onRefreshWebinars,
  // is_admin,
  // notification_enabled,
  // onFieldChange,
  // novonordiskSubscribed,
  // toggleNovonordiskSubscription
}) => (
  <div>
    {/*{!is_admin &&*/}
    {/*<div className="email_notification_sponsor">*/}
    {/*  <FormControlLabel*/}
    {/*    control={*/}
    {/*      <Checkbox*/}
    {/*        checked={novonordiskSubscribed}*/}
    {/*        name='subscription_sponsor'*/}
    {/*        onChange={() => toggleNovonordiskSubscription({*/}
    {/*          target: {*/}
    {/*            name: 'novonordiskSubscribed', value: !novonordiskSubscribed*/}
    {/*          }*/}
    {/*        })}*/}
    {/*      />*/}
    {/*    }*/}
    {/*    label={<span className="email_notification_label">*/}
    {/*      <span>Check the box if you like to be kept informed about future Masterclasses from<span className='novo_nordisk_text'>Novo Nordisk</span> </span>*/}
    {/*              </span>}*/}
    {/*  />*/}
    {/*</div>*/}
    {/*}*/}
    <div className="section_webinars_desc">
      <h2 className="main_title" id="current">
        Current Meetings
      </h2>
    </div>

    <div className="container_current row">{webinars}</div>
    {pagination && (
      <a className="more_item" href="javascript:void(0)" onClick={nextPage}>
        LOAD MORE
      </a>
    )}
    {!count && (
      <div>
        <p className="has_no_items">
          There are no webinars currently running, click below to refresh
        </p>
        <button className="section_refresh_button" onClick={onRefreshWebinars}>
          Refresh
        </button>
      </div>
    )}
  </div>
);

CurrentWebinars.propTypes = {
  webinar: PropTypes.obj,
  joinToWebinar: PropTypes.func,
};

export default CurrentWebinars;



// WEBPACK FOOTER //
// ./src/components/Dashboard/CurrentWebinars/CurrentWebinars.js